import { render, staticRenderFns } from "./face-swap.vue?vue&type=template&id=405f2b1b&scoped=true&"
import script from "./face-swap.vue?vue&type=script&lang=js&"
export * from "./face-swap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405f2b1b",
  null
  
)

export default component.exports